import { RootState } from 'store/store';

export const selectPositionData = (state: RootState) => state.position.position;
export const selectPositionRequestStatus = (state: RootState) => state.position.positionRequestStatus;
